module.exports = __webpack_public_path__ + "img/gzh.52972158.jpg";